<template>
  <div class="container exam-create">
    <div class="header">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/member/notice' }"
          >消息推送</el-breadcrumb-item
        >
        <el-breadcrumb-item>消息推送</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left"></div>
        <div class="right">
          <el-button plain @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit">保存并推送</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">推送设置</h3>
      <div class="content">
        <el-form
          class="dataForm"
          ref="dataForm"
          label-position="left"
          label-width="100px"
        >
          <el-form-item label="消息标题：">
            <el-input
              v-model="notice.title"
              type="textarea"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="消息描述：">
            <el-input
              v-model="notice.description"
              type="textarea"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="消息图片：">
            <img v-if="notice.picture_url" :src="notice.picture_url" style="max-height: 120px;">
            <div v-else>无</div>
          </el-form-item>
          <el-form-item label="关联内容：">
            <div v-if="notice.ref_content">{{notice.ref_content.name || notice.ref_content.title}}</div>
            <div v-else>无</div>
          </el-form-item>
          <el-form-item label="推送对象：">
            <el-radio-group v-model="chooseType" @change="handleChooseTypeChange" style="line-height: 40px;">
              <div><el-radio :label="1">全体用户广播</el-radio></div>
              <div><el-radio :label="2">自定义</el-radio></div>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="">
            <el-form-item label="分组选择">
              <el-select v-model="groups" multiple placeholder="请选择" :disabled="chooseType != 2" style="width: 100%;">
                <el-option
                  v-for="item in categorys"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户选择">
              <div class="tag-wrap">
                <el-tag
                  class="user-item"
                  size="medium"
                  :key="item.id"
                  v-for="item in users"
                  closable
                  :disable-transitions="false"
                  @close="handleUserRemove(item)"
                >
                  {{
                    item.mobile
                      ? `${item.nickname || item.username}/${item.mobile}`
                      : item.nickname || item.username
                  }}
                </el-tag>
                <el-button type="text" @click="handleUserChoose" :disabled="chooseType != 2">选择用户</el-button>
              </div>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <MemberChoose
      :visible="userChooseDialog"
      :users="users"
      @close="userChooseDialog = false"
      @submit="saveMember"
    ></MemberChoose>
  </div>
</template>

<script>
import MemberChoose from "@/components/dialog/member/MemberChoose";
import { noticeOne, noticePush } from "@/api/operation";
import { memberCategoryList } from "@/api/member";

export default {
  components: {
    MemberChoose,
  },
  data() {
    return {
      userChooseDialog: false,
      notice: {},
      users: [],
      groups: [],
      categorys: [],
      chooseType: 1,
    };
  },
  created() {
    this.fetchNoticeInfo();
    this.fetchCategoryList();
  },
  methods: {
    fetchNoticeInfo() {
      noticeOne({ id: this.$route.params.noticeId }).then((res) => {
        this.notice = res;
      });
    },
    // 用户分组列表请求
    fetchCategoryList() {
      memberCategoryList({isPaging: 0}).then(res => {
        this.categorys = res.list
      })
    },
    handleUserChoose() {
      this.userChooseDialog = true;
    },
    handleUserRemove(item) {
      this.users = this.users.filter((v) => v.id !== item.id);
    },
    saveMember({ users }) {
      this.users = users;
    },
    handleChooseTypeChange(type) {
      if (type == 1) {
        this.users = []
        this.groups = []
      }
    },
    handleSubmit() {
      const params = {
        notice_id: Number(this.$route.params.noticeId),
        chooseType: this.chooseType,
        users: this.users.map(v => ({id: v.id})),
        groups: this.groups.map(v => ({id: v}))
      }
      if (params.chooseType == 2 && !params.users.length && !params.groups.length) {
        this.$message.warning(`自定义推送对象，分组和用户不能全部为空`)
        return
      }
      console.log(params)
      noticePush(params).then(res => {
        this.$message.success(`消息推送完成`)
        this.handleClose()
      })
    },
    handleClose() {
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped lang="less">
.exam-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;

    .dataForm {
      min-width: 700px;
      width: 100%;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
    .cover-wrap {
      .top {
        display: flex;
        margin-bottom: 10px;
      }
      .left,
      .right {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .middle {
        flex: 1;
      }
      .cover-selected {
        width: 92px;
        height: 125px;
      }
      .covers {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: space-between;
        width: 215px;
        height: 105px;
      }
      .cover-item {
        width: 50px;
        height: 68px;
        cursor: pointer;

        &:not(:nth-child(4n)) {
          margin-right: 5px;
        }
      }
      .el-upload__tip {
        line-height: 20px;
      }
    }
    .form-item-wrap {
      display: flex;

      /deep/ .el-input {
        width: 300px;
      }
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .user-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
}
</style>
